module.exports = __webpack_public_path__ + "static/media/5.41fc2a5a.svg";